<style lang="scss" scoped>
@use '~@/styles/main';
@use '~@/styles/base/variables';

.notification-panel {
  min-width: 505px;
  position: sticky;
  top: 0px;
  z-index: 100;
}

.msg {
  display: flex;
  background-color: #232838;
  font-size: 16px;
  border: 1px solid gray;
  border-radius: 5px;
  margin-bottom: 5px;

  &__reload {
    padding: 5px 30px;
  }

  &__html-content {
    flex: 1;
    padding: 10px;
  }

  &__close {
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    padding: 0 10px;

    &:hover {
      background: linear-gradient(to bottom left, var(--color-accent-dark), var(--color-accent));
      background-clip: text;
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
    }
  }

  &_info {
    align-items: stretch;
  }

  &_newupdate {
    padding: 8px;
    justify-content: center;
    align-items: center;
    gap: 20px;
  }
}

.div1 {
  /*border: 2px solid crimson;*/
}

.main {
  padding-top: 10px;
  padding-left: variables.$menu-width + 10px;
  padding-right: 10px;
  overflow: hidden;
  min-height: 100vh;
  /*background-color: #2A2F44;*/
  /*width: 1300px;*/
  /*min-width: 1050px;*/
  /*padding-right: 20px;*/
}

.fit-content {
  min-width: fit-content;
}

.spacer {
  height: 15px;
}

@media screen and (max-width: variables.$xs) {
  .main {
    padding-left: 5px;
    padding-right: 5px;
    padding-bottom: variables.$mobile-menu-height;
  }
}

@media screen and (max-width: variables.$small) {
  .main {
    min-width: fit-content;
  }
}
</style>

<template>
  <div>
    <Menu />
    <div
      id="main"
      class="main"
      :class="{ 'fit-content': !isTerminalAdvanced }"
    >
      <div class="notification-panel">
        <div
          v-if="showUpdate"
          class="msg msg_newupdate"
        >
          <span>
            {{ $text.tr('Доступно новое обновление') }}
          </span>
          <Button
            class="msg__reload"
            type="primary"
            @click="refresh"
          >
            {{ $text.tr('Обновить страницу') }}
          </Button>
        </div>
        <div
          v-if="sysMsg.Msg && ignoreMsgId != sysMsg.Id"
          class="msg msg_info"
        >
          <div
            class="msg__html-content"
            v-html="sysMsg.Msg"
          />
          <Icon
            size="36"
            type="ios-close"
            class="msg__close"
            @click="ignoreMsgId = sysMsg.Id"
          ></Icon>
        </div>
      </div>
      <Header2
        v-show="$route.meta.showHeader"
        :showConstructorSwitch="isTerminalAdvanced"
      />
      <div
        v-show="$route.meta.showHeader"
        class="spacer"
      ></div>
      <router-multi-view />
      <router-multi-view
        v-if="$store.state.sys.isConstructorModeAllowed"
        view-name="terminal-advanced"
      />
      <router-multi-view
        v-else
        view-name="terminal-default"
      />
    </div>
    <SlTpModal />
    <ExchangeModal />
    <ConfirmRebuy
      :show="$store.state.rebuyModal.show"
      :trade="$store.state.rebuyModal.rebuyTrade"
      @on-cancel="$store.state.rebuyModal.show = false"
      @rebought="$store.state.rebuyModal.show = false"
    />
    <Confirm
      :show="$store.state.confirmActionModal.show"
      :text="$store.state.confirmActionModal.text"
      :btname="$store.state.confirmActionModal.btnName"
      @on-cancel="$store.state.confirmActionModal.show = false"
      @confirmed="
        $store.state.confirmActionModal.actionFunc(
          $store.state.confirmActionModal.tradeId,
          $store.state.confirmActionModal.actionId
        )
      "
    />
  </div>
</template>

<script>
import Header2 from '@/components/common/Header/Header2'
import Menu from '../Menu'
import SlTpModal from '../SlTpModal'
import terminal from '@/services/terminal'
import ExchangeModal from '@/components/common/Header/ExchangeModal'
import ConfirmRebuy from '@/components/MainPage/Terminal/ConfirmRebuyModal'
import Confirm from '@/components/common/Confirm'
import axios from 'axios'
import Api from '@/util/api'
import Data from '@/util/data'
import fastbot from '../../services/fastbot'
import ReconnectingWebSocket from 'reconnecting-websocket'
// import PageTitle from '../common/PageTitle'

export default {
  name: 'MainPage',
  components: {
    Header2,
    SlTpModal,
    Menu,
    ExchangeModal,
    ConfirmRebuy,
    Confirm
  },
  data () {
    return {
      exchValueInterval: null,
      updateRatesInterval: null,
      updateAssetsInterval: null,
      refreshTokenInterval: null,
      checkUpdateInterval: null,
      checkSysMsgInterval: null,
      updateSymbolsInterval: null,
      showUpdate: false,
      sysMsg: {},
      ignoreMsgId: 0
    }
  },
  watch: {
    '$store.state.trade.symbol': function (symbol) {
      this.$store.state.trade.pair = symbol.split('_')
      this.$store.state.sys.freeBalance = ''
      // var res = symbol.split("_")
      // this.baseAsset = res[0]
      // this.quoteAsset = res[1]
      // this.$store.state.trade.qty = "0" // new Decimal("0.00000000")
      // this.updateAssetBalance()

      this.$store.dispatch('updateAssetBalance')

      this.$store.state.trade.slprice = ''
      this.$store.state.trade.tpprice = ''
      this.$store.state.trade.sltrail = ''
      this.$store.state.trade.tptrail = ''
      this.$store.state.trade.tpsteps = []
    },
    '$store.state.trade.showTV' (showTV) {
      localStorage.setItem('capico_app_showTV', showTV)
    },
    '$store.state.sys.tradeExchange': function (newExch) {
      this.$store.dispatch('updateAssets')

      let newSymbol = 'BTC_USDT'
      if (
        this.$store.state.sys.selSymbols &&
        this.$store.state.sys.selSymbols[newExch.Id]
      ) {
        newSymbol = this.$store.state.sys.selSymbols[newExch.Id]
      } else {
        switch (newExch.ExchId) {
          case 'BIN':
          case 'BIM':
          case 'BIF':
            newSymbol = 'BTC_USDT'
            break
          case 'EXM':
            newSymbol = 'BTC_USD'
            break
          case 'HUO':
            newSymbol = 'BTC_USDT'
            break
          case 'BIT':
            newSymbol = 'BTC_USD'
            break
          case 'FTX':
            newSymbol = 'BTC_USDT'
        }
      }

      this.$store.dispatch('updateSymbols')
      this.$store.state.trade.symbol = newSymbol
      this.$store.state.sys.chartInfo = {
        ExchId: newExch.ExchId,
        TradeSymbol: newSymbol
      }
      this.$store.state.sys.lastTrade = Date.now()
    },
    '$store.state.sys.lastTrade': function () {
      this.$store.dispatch('updateAssets')
    }
  },
  computed: {
    isTerminalAdvanced () {
      return (
        this.$route.name === 'terminal' &&
        this.$store.state.sys.isConstructorModeAllowed
      )
    },
    price () {
      if (this.$route.name === 'bots') {
        return this.$store.state.bots.lastPrice
      } else if (this.$route.name === 'terminal') {
        return this.$store.state.sys.lastPrice
      } else {
        return ''
      }
    },
    symbol () {
      if (this.$route.name === 'bots') {
        return this.$store.state.bots.symbol.replace('_', '/')
      } else if (this.$route.name === 'terminal') {
        return this.$store.state.trade.symbol.replace('_', '/')
      } else {
        return ''
      }
    },
    isMenuCollapsed: {
      get () {
        return this.$store.state.sys.isMenuCollapsed
      },
      set (value) {
        this.$store.state.sys.isMenuCollapsed = value
        localStorage.setItem('isMenuCollapsed', value)
      }
    },
    isHeaderCollapsed: {
      get () {
        return this.$store.state.sys.isHeaderCollapsed
      },
      set (value) {
        this.$store.state.sys.isHeaderCollapsed = value
        localStorage.setItem('isHeaderCollapsed', value)
      }
    }
  },
  methods: {
    onKeyDown (e) {
      if (e.repeat || document.activeElement.tagName === 'INPUT' || document.activeElement.tagName === 'TEXTAREA') {
        return
      }

      switch (e.key.toLowerCase()) {
        case 'w':
        case 'ц':
          this.$bus.$emit('toggle-smart-trade')
          break

        case 'q':
        case 'й':
          this.toggleFullScreen()
          break

        case 'z':
        case 'я':
          this.switchExchange('switch-to-previous-exchange')
          break

        case 'x':
        case 'ч':
          this.switchExchange('switch-to-next-exchange')
          break
      }
    },
    switchExchange (emitTitle) {
      if (!this.$route.meta.showHeader) {
        return
      }

      if (
        !this.$store.state.trade.tvEnabled &&
        this.$store.state.trade.tvLoading
      ) {
        return
      }

      this.$bus.$emit(emitTitle)
    },
    toggleFullScreen () {
      if (this.$route.meta.showHeader) {
        if (this.isMenuCollapsed && this.isHeaderCollapsed) {
          this.isMenuCollapsed = false
          this.isHeaderCollapsed = false
        } else {
          this.isMenuCollapsed = true
          this.isHeaderCollapsed = true
        }
      } else {
        this.isMenuCollapsed = !this.isMenuCollapsed
      }
    },
    getSysMsg () {
      Api.get('sys/msg', {
        params: {
          token: this.$store.state.sys.token
        }
      })
        .then(response => {
          if (response.data) {
            this.sysMsg = response.data
          }
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    refresh () {
      window.location.reload()
    },
    checkVersion () {
      const uri = window.location.origin + '/app/v.json'
      // console.log('site', window.location.origin, uri)
      // var uri = 'https://capico.app/app/v.json'
      // var uri = 'http://localhost:8083/app/v.json'
      axios
        .get(uri)
        .then(response => {
          // console.log(response.data)
          if (
            response.data.v &&
            response.data.v !== process.env.VUE_APP_VERSION
          ) {
            this.showUpdate = true
          }
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    infows () {
      // console.log('capico ws info')
      console.log('capico ws open', window.capicows.url)
    },
    infowssg () {
      // console.log('capico ws info')
      console.log('capico ws sg open', window.capicowssg.url)
    },
    onmessage (e) {
      // console.log('capico ws sg msg111:', e.data)

      const etid = e.data.slice(19)

      // update only if this exch is active
      if (etid !== this.$store.state.sys.tradeExchange.Id) {
        return
      }
      this.$store.dispatch('updateTrades')
      this.$store.dispatch('updateAssets')
      this.$store.state.bots.botsUpdated = Date.now()
      if (this.$store.state.trade.editTrade) {
        setTimeout(() => {
          terminal.tradeGetAndUpdate(this.$store.state.trade.editTrade.Id)
        }, 1000)
      }
    },
    initWs () {
      // console.log('capico ws connecting...')
      const wsUri = process.env.VUE_APP_BASE_URL.replace('https', 'wss').replace(
        ':2505',
        ':2525'
      )

      if (!window.capicows) {
        setInterval(() => {
          if (window.capicows && window.capicows.readyState === 1) {
            window.capicows.send('ping')
            // console.log('ping sent', window.capicows.url)
          }
        }, 90000)
        // console.log('ping interval created')
      }

      window.capicows = new WebSocket(
        wsUri + 'ws?token=' + this.$store.state.sys.token
      )
      // window.capicows.onopen = this.infows
      window.capicows.onclose = () => {
        // console.log('capico ws closed', window.capicows.url)
        setTimeout(this.initWs, 2000)
      }
      window.capicows.onmessage = e => {
        // console.log('capico ws msg:', window.capicows.url, e.data)
        this.onmessage(e)
      }
    },
    initWsSg () {
      // console.log('capico ws sg connecting...')
      let wsUri = process.env.VUE_APP_BASE_URL.replace('https', 'wss').replace(
        ':2505',
        ':2525'
      )

      if (!window.capicowssg) {
        setInterval(() => {
          if (window.capicowssg && window.capicowssg.readyState === 1) {
            window.capicowssg.send('ping')
            // console.log('sg ping sent', window.capicowssg.url)
          }
        }, 90000)
        // console.log('sg ping interval created')
      }

      wsUri = wsUri.replace('titan', 'sgtitan')
      wsUri = wsUri.replace('wss://capico', 'wss://sg.capico').replace('wss://titan', 'wss://sgtitan')

      window.capicowssg = new WebSocket(
        wsUri + 'ws?token=' + this.$store.state.sys.token
      )
      // window.capicowssg.onopen = this.infowssg
      window.capicowssg.onclose = () => {
        // console.log('capico ws sg closed', window.capicowssg.url)
        setTimeout(this.initWsSg, 2000)
      }
      window.capicowssg.onmessage = e => {
        // console.log('capico ws sg msg:', window.capicowssg.url, e.data)
        this.onmessage(e)
      }
    },
    initWsGet () {
      // console.log('capico ws sg connecting...')
      let wsUri = process.env.VUE_APP_BASE_URL.replace('https', 'wss').replace(
        ':2505',
        ':2525'
      )

      if (!window.capicowsget) {
        setInterval(() => {
          if (window.capicowsget && window.capicowsget.readyState === 1) {
            window.capicowsget.send('ping')
            // console.log('sg ping sent', window.capicowsget.url)
          }
        }, 90000)
        // console.log('sg ping interval created')
      }

      wsUri = wsUri.replace('titan', 'gettitan')
      wsUri = wsUri.replace('wss://capico', 'wss://get.capico').replace('wss://titan', 'wss://gettitan')

      window.capicowsget = new WebSocket(
        wsUri + 'ws?token=' + this.$store.state.sys.token
      )
      // window.capicowsget.onopen = this.infowssg
      window.capicowsget.onclose = () => {
        // console.log('capico ws sg closed', window.capicowsget.url)
        setTimeout(this.initWsGet, 2000)
      }
      window.capicowsget.onmessage = e => {
        // console.log('capico ws sg msg:', window.capicowsget.url, e.data)
        this.onmessage(e)
      }
    },
    initWsOld (id) {
      let wsUri = process.env.VUE_APP_BASE_URL.replace('https', 'wss').replace(
        ':2505',
        ':2525'
      )

      let openfunc = this.openws

      if (id === 2) {
        wsUri = wsUri.replace('titan', 'sgtitan')
        wsUri = wsUri.replace('wss://capico', 'wss://sg.capico').replace('wss://titan', 'wss://sgtitan')
        openfunc = this.openws2
        window.capicows2 = new WebSocket(
          wsUri + 'ws?token=' + this.$store.state.sys.token
        )
        window.capicows2.onopen = this.infows2
      } else if (id === 1) {
        window.capicows = new WebSocket(
          wsUri + 'ws?token=' + this.$store.state.sys.token
        )
        window.capicows.onopen = this.infows
      }

      // let ws = new WebSocket(
      //   wsUri + 'ws?token=' + this.$store.state.sys.token
      // )

      setInterval(() => {
        if (ws) {
          ws.send('ping')
          console.log('ping sent', ws.url)
        }
      }, 90000)

      ws.onopen = this.infows

      // ws.onopen = () => {
      //   this.infows()
      // }

      // ws.onopen = () => {
      //   console.log('capico ws connected', ws.url)
      //   // let msg1 = '{"method":"subscribe","params":{"channel":"BTC_USD_15"},"uid":"1"}'
      //   // ws.send('ping')
      // }

      ws.onerror = error => {
        console.log('capico ws error:', error)
      }

      ws.onclose = openfunc

      // ws.onclose = () => {
      //   console.log('capico ws closed', ws.url)
      //   ws = new WebSocket(
      //     wsUri + 'ws?token=' + this.$store.state.sys.token
      //   )
      // }

      ws.onmessage = e => {
        console.log('capico ws msg:', ws.url, e.data)

        // let etid = e.data.slice(-4)

        const etid = e.data.slice(19)

        // update only if this exch is active
        if (etid !== this.$store.state.sys.tradeExchange.Id) {
          return
        }
        this.$store.dispatch('updateTrades')
        this.$store.dispatch('updateAssets')
        this.$store.state.bots.botsUpdated = Date.now()
        if (this.$store.state.trade.editTrade) {
          // console.log('editTrade:', this.$store.state.trade.editTrade)
          setTimeout(() => {
            terminal.tradeGetAndUpdate(this.$store.state.trade.editTrade.Id)
          }, 1000)
          // console.log('tradeGetAndUpdate & updateTrades forced for trade: ', this.$store.state.trade.editTrade.Id)
        }
      }
    }
  },
  mounted () {
    // if (process.env.VUE_APP_BASE_URL.includes('moon')) {
    //   this.$Countly.q.push(['begin_session'])
    //   this.$Countly.q.push(['track_sessions'])
    //   this.$Countly.q.push(['track_clicks'])
    //   this.$Countly.q.push(['track_errors'])
    //   this.$Countly.q.push(['track_links'])
    // }

    this.initWs()

    setTimeout(() => {
      const sgsptnk = this.$store.state.sys.exchanges.find((exch) => exch.sptnk === 'sg')
      if (sgsptnk) {
        this.initWsSg()
      }
    }, 3000)

    setTimeout(() => {
      const sptnk = this.$store.state.sys.exchanges.find((exch) => exch.sptnk === 'get')
      if (sptnk) {
        this.initWsGet()
      }
    }, 4000)

    document.addEventListener('keydown', this.onKeyDown)
  },
  async created () {
    Data.vm = this

    await this.$store.dispatch('updateSymbols')
    // console.log('MainPage created')
    //
    // console.time('updateExchanges')
    // console.log('updateExchangesAsync from MainPage')
    await this.$store.dispatch('updateExchangesAsync')
    // console.log('updateExchanges exit')
    // console.timeEnd('updateExchanges')

    // load symbols and update asset balance
    // await this.$store.dispatch('updateSymbols')

    this.$store.dispatch('updateAssets')
    this.updateAssetsInterval = setInterval(() => {
      this.$store.dispatch('updateAssets')
    }, 60000)
    // console.log('updateExchanges enter')

    this.refreshTokenInterval = setInterval(
      terminal.terminalRefreshToken,
      10 * 60000
    ) // 10 minutes

    terminal.updateRates()
    this.updateRatesInterval = setInterval(terminal.updateRates, 60000)

    // terminal.updateExchValue()
    this.exchValueInterval = setInterval(terminal.updateExchValue, 120000)

    if (!process.env.VUE_APP_BASE_URL.includes('titan')) {
      this.checkVersion()
      this.checkUpdateInterval = setInterval(this.checkVersion, 120000)
    }

    this.getSysMsg()
    this.checkSysMsgInterval = setInterval(this.getSysMsg, 60000)

    this.updateSymbolsInterval = setInterval(() => {
      this.$store.dispatch('updateSymbols')
    }, 120000)
    setTimeout(() => {
      this.$store.dispatch('updateAssetBalance')
    }, 1000)
  },
  beforeDestroy () {
    document.removeEventListener('keydown', this.onKeyDown)
    // console.log('MainPage beforeDestroy', this)
    const todestroy = []
    this.$children.forEach(child => {
      // console.log(child.$vnode.tag)

      if (
        child.$vnode.tag.includes('Terminal') ||
        child.$vnode.tag.includes('RefCab') ||
        child.$vnode.tag.includes('Portfolio') ||
        child.$vnode.tag.includes('Pay') ||
        child.$vnode.tag.includes('Bots') ||
        child.$vnode.tag.includes('Grids') ||
        child.$vnode.tag.includes('FastBot') ||
        child.$vnode.tag.includes('Settings')
      ) {
        todestroy.push(child)
      }
    })

    todestroy.forEach(function (el) {
      // console.log('destroing ', el.$vnode.tag)
      el.$destroy()
    })
  },
  destroyed () {
    clearInterval(this.checkSysMsgInterval)
    if (this.checkUpdateInterval) {
      clearInterval(this.checkUpdateInterval)
    }
    clearInterval(this.refreshTokenInterval)
    clearInterval(this.exchValueInterval)
    clearInterval(this.updateRatesInterval)
    clearInterval(this.updateAssetsInterval)
    clearInterval(this.updateSymbolsInterval)
  }
}
</script>
